import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = {
  class: "btn btn-sm btn-outline-dark text-capitalize",
  for: "group-all"
}
const _hoisted_15 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "group-new"
}
const _hoisted_16 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "group-deactivated"
}
const _hoisted_17 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_18 = { class: "col p-0" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_21 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_22 = { class: "col p-0" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_25 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_26 = { class: "col p-0" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_29 = { class: "col p-0" }
const _hoisted_30 = { class: "form-check small mb-0 mt-1" }
const _hoisted_31 = {
  class: "form-check-label",
  for: "isActive"
}
const _hoisted_32 = { class: "form-group mb-2 col" }
const _hoisted_33 = { class: "col-auto p-0 text-end" }
const _hoisted_34 = { class: "row mt-3" }
const _hoisted_35 = { class: "col text-end" }
const _hoisted_36 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_37 = { class: "col-sm-12" }
const _hoisted_38 = { class: "card card-body mb-0" }
const _hoisted_39 = { class: "overflow-auto" }
const _hoisted_40 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_41 = { class: "bg-light" }
const _hoisted_42 = { class: "text-capitalize-first" }
const _hoisted_43 = { class: "text-capitalize-first" }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = { class: "text-capitalize-first" }
const _hoisted_53 = { class: "text-capitalize-first" }
const _hoisted_54 = { class: "text-capitalize-first" }
const _hoisted_55 = { class: "text-capitalize-first" }
const _hoisted_56 = { class: "text-capitalize-first" }
const _hoisted_57 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                          placeholder: _ctx.helper.trans('labels.name'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                        }, null, 40, _hoisted_10), [
                          [_vModelText, _ctx.requestDTO.query]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.periodType) = $event)),
                          value: "all",
                          class: "btn-check",
                          name: "options-outlined",
                          id: "group-all",
                          autocomplete: "off",
                          checked: ""
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.periodType]
                        ]),
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.all')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.periodType) = $event)),
                          value: "new",
                          class: "btn-check",
                          name: "options-outlined",
                          id: "group-new",
                          autocomplete: "off"
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.periodType]
                        ]),
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.new_traders')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.periodType) = $event)),
                          value: "deactivated",
                          class: "btn-check",
                          name: "options-outlined",
                          id: "group-deactivated",
                          autocomplete: "off"
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.periodType]
                        ]),
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.deactivated_traders')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_20)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_24)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_TeamLeadMultiselect, {
                          multiple: false,
                          modelValue: _ctx.teamLeadFilter,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.teamLeadFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.isActive) = $event)),
                          "true-value": "y",
                          type: "checkbox",
                          value: "",
                          id: "isActive"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.requestDTO.isActive]
                        ]),
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.helper.trans('labels.only_active')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(() => _ctx.downloadReport(), ["prevent"])),
                      class: "btn btn-link btn-sm m-0 p-0 text-capitalize-first"
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.download_report')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_41, [
                    _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                    _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                    _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.email')), 1),
                    _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.reg_date')), 1),
                    _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.helper.trans('labels.is_blocked')), 1),
                    _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.helper.trans('labels.block_reason')), 1),
                    _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.helper.trans('labels.blocked_at')), 1),
                    _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('labels.first_deal_at')), 1),
                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('labels.last_deal_at')), 1),
                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('labels.completed_turnover_amount_usdt')), 1),
                    _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.helper.trans('labels.balance_usdt')), 1),
                    _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.helper.trans('labels.frozen_balance_usdt')), 1),
                    _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.helper.trans('labels.insurance_amount_usdt')), 1),
                    _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.helper.trans('labels.insurance_limit_usdt')), 1),
                    _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.helper.trans('labels.last_deposit_at')), 1),
                    _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.helper.trans('labels.last_withdrawal_at')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.email), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.regDate)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.isBlocked), 1),
                      _createElementVNode("td", null, _toDisplayString(item.blockReason), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.blockedAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.firstDealAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.lastDealAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.completedTurnoverAmountUsdt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.balanceAmountUsdt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.frozenAmountUsdt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.insuranceAmountUsdt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.insuranceLimitUsdt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.lastDepositAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.lastWithdrawalAt)), 1)
                    ]))
                  }), 256))
                ])
              ]),
              (_ctx.response.totalCount > _ctx.response.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.page,
                    "onUpdate:modelValue": [
                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.page) = $event)),
                      _cache[13] || (_cache[13] = ($event: any) => (_ctx.load()))
                    ],
                    "total-rows": _ctx.response.totalCount,
                    "per-page": _ctx.response.limit,
                    limit: 20,
                    "prev-text": "Back",
                    "next-text": "Next",
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}